<script>
import PayoutTransactionListTab from './components/PayoutTransactionListTab.vue';
import EmailControlTab from './components/EmailControlTab.vue';

export default {
  name: 'PayoutBatchArbitrage',
  components: { PayoutTransactionListTab, EmailControlTab },
  data() {
    return {
      // index 0 is Payout/ Transaction List (default active)
      activeIndex: 0,
    };
  },
  beforeRouteLeave(to, from, next) {
     const payoutHeaderIds = JSON.parse(localStorage.getItem('ids')) || [];
     console.log(payoutHeaderIds);
     if(payoutHeaderIds.length === 0) {
      next();
      return;
     }
     if(this.$refs.payoutTransactionTab && payoutHeaderIds.length > 0) {
      this.$refs.payoutTransactionTab.payoutHeaderIds = payoutHeaderIds;
       this.$refs.payoutTransactionTab.deletePayoutBatch();
       next();
     }
  },
};
</script>

<template>
  <div>
    <b-card no-body>
      <b-tabs card v-model="activeIndex">
        <b-tab title="Payout/ Transaction List">
          <b-card-text>
            <keep-alive>
              <PayoutTransactionListTab ref="payoutTransactionTab"/>
            </keep-alive>
          </b-card-text>
        </b-tab>
        <b-tab title="Email Control">
          <b-card-text>
            <keep-alive>
              <EmailControlTab />
            </keep-alive>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>